"use client"

import React from 'react';
import styles from "./Footer.module.scss";
import {Link} from "@/i18n/routing";
import Image from "next/image";
import packageConfig from "../../package.json";
import {AppBar, Toolbar} from "@mui/material";
import {useTranslations} from "use-intl";

const Footer = () => {
  const t = useTranslations("Main")
  return (<AppBar className={styles.container} sx={{top: 'auto', bottom: 0, padding: '0.2rem', backgroundColor: '#fff'}}
                  position={"fixed"}>
    <Toolbar className={styles.toolbar}>
      <Link href={`/home`}>
        <Image unoptimized className={styles.image} style={{marginTop: '0.3rem'}} width={120} height={35}
               src={'/Logo-Color-L.svg'}
               alt={'logo'}/>
      </Link>
      <div className={styles.copyright}>
        <strong>&copy; 2025 Chiesa Cattolica. Tutti i diritti riservati |&nbsp;
          <Link className={styles.link} href={`/credits`}>Credits</Link>&nbsp;|&nbsp;
          <Link className={styles.link} href={`https://www.camminidellafede.it/privacy-policy/`}>Privacy
            Policy</Link>&nbsp;|&nbsp;
          <Link className={styles.link} href={`mailto:assistenza@camminidellafede.it`}>{t("report")}</Link>
        </strong>
      </div>
      <div className={styles.bottomRow}>
        <strong>v.{packageConfig.version}</strong>
      </div>
    </Toolbar>
  </AppBar>)
};

export default Footer;
